<button
  class="secondary-button"
  type="button"
  aria-controls="settings-menu"
  [attr.aria-expanded]="facade.isSettingsMenuOpen()"
  (click)="facade.toggleSettingsMenu()"
>
  Controls
</button>

@if (facade.isSettingsMenuOpen()) {
  <div class="settings-backdrop" role="presentation" (click)="facade.closeSettingsMenu()"></div>

  <aside
    id="settings-menu"
    class="settings-drawer"
    aria-label="Map controls"
    (click)="$event.stopPropagation()"
  >
    <header class="settings-drawer__header">
      <div>
        <h2>Controls</h2>
        <p>{{ facade.modeLabel() }} · {{ facade.apiHealthLabel() }}</p>
      </div>

      <button
        class="settings-drawer__close"
        type="button"
        aria-label="Close controls"
        (click)="facade.closeSettingsMenu()"
      >
        &times;
      </button>
    </header>

    <section class="settings-section" aria-label="Replay controls">
      <div class="settings-section__header">
        <h3>Replay</h3>
        @if (facade.isReplayActive()) {
          @if (facade.isReplayPaused()) {
            <span class="settings-section__badge">Paused</span>
          } @else {
            <span class="settings-section__badge settings-section__badge--active">On</span>
          }
        } @else {
          <span class="settings-section__badge">Off</span>
        }
      </div>

      <label class="settings-field">
        <span>Start time</span>
        <input
          type="datetime-local"
          step="1"
          [value]="facade.replayDateTimeInput()"
          (change)="updateReplayDateTime($event)"
        />
      </label>

      <label class="settings-field">
        <span>Speed</span>
        <select [value]="facade.replaySpeed()" (change)="updateReplaySpeed($event)" aria-label="Replay speed">
          @for (speed of facade.replaySpeedOptions; track speed) {
            <option [value]="speed">{{ speed }}x</option>
          }
        </select>
      </label>

      <div class="settings-actions">
        @if (facade.isReplayActive()) {
          <button class="primary-button" type="button" (click)="facade.toggleReplayPlayback()">
            {{ facade.replayPlaybackLabel() }}
          </button>
        } @else {
          <button class="primary-button" type="button" (click)="facade.startReplay()">Start replay</button>
        }

        @if (facade.isReplayActive()) {
          <button
            class="secondary-button secondary-button--full replay-stop-button"
            type="button"
            title="Stop replay and return to the live feed"
            data-tooltip="Returns to live feed"
            (click)="facade.stopReplay()"
          >
            Stop replay
          </button>
        }
      </div>
    </section>

    <section class="settings-section" aria-label="Map baselayer">
      <div class="settings-section__header">
        <h3>Map</h3>
      </div>

      <div class="baselayer-toggle" role="radiogroup" aria-label="Map baselayer">
        <label
          class="baselayer-toggle__option"
          [class.baselayer-toggle__option--active]="facade.baseLayer() === 'osm'"
        >
          <input
            type="radio"
            name="base-layer"
            value="osm"
            [checked]="facade.baseLayer() === 'osm'"
            (change)="updateBaseLayer($event)"
          />
          <span>OSM</span>
        </label>

        <label
          class="baselayer-toggle__option"
          [class.baselayer-toggle__option--active]="facade.baseLayer() === 'ortho'"
        >
          <input
            type="radio"
            name="base-layer"
            value="ortho"
            [checked]="facade.baseLayer() === 'ortho'"
            (change)="updateBaseLayer($event)"
          />
          <span>Ortho</span>
        </label>
      </div>
    </section>

    <section class="settings-section" aria-label="Refresh controls">
      <div class="settings-section__header">
        <h3>Refresh</h3>
      </div>

      <label class="refresh-interval">
        <span>Every</span>
        <input
          type="number"
          min="100"
          max="360000"
          step="50"
          [value]="facade.refreshIntervalMs()"
          (change)="updateRefreshInterval($event)"
          aria-label="Refresh interval in milliseconds"
        />
        <span>ms</span>
      </label>
    </section>

    <section class="settings-section" aria-label="Detected drone controls">
      <div class="settings-section__header">
        <h3>Drones detected</h3>
        <span class="settings-section__badge">{{ facade.activeDetectedDroneCount() }}</span>
      </div>

      <label class="drone-toggle">
        <input
          type="checkbox"
          [checked]="facade.isDroneLayerVisible()"
          (change)="updateDroneLayerVisibility($event)"
        />
        <span>Show detected drones</span>
      </label>

      <div class="settings-grid">
        <label class="settings-field">
          <span>Lookback s</span>
          <input
            type="number"
            min="1"
            max="3600"
            step="1"
            [value]="facade.detectedDroneLookbackSeconds()"
            (change)="updateDroneLookbackSeconds($event)"
          />
        </label>

        <label class="settings-field">
          <span>Stale ms</span>
          <input
            type="number"
            min="1000"
            max="120000"
            step="500"
            [value]="facade.detectedDroneStaleAfterMs()"
            (change)="updateDroneStaleAfter($event)"
          />
        </label>
      </div>
    </section>
  </aside>
}
